import { Appointment } from "../types/appointment.definition";
import {
  cancelAppointment,
  createAppointment,
  getAppointmentById,
  updateAppointment,
} from "../webclients/appointment.client";

export const appointmentApi = {
  getAppointmentById: async (appointmentId: string): Promise<Appointment> => {
    const response = await getAppointmentById(appointmentId);
    return response.data;
  },
  updateAppointment: async (appointmentId: string, data: Appointment) => {
    const response = await updateAppointment(data, appointmentId);
    return response.data;
  },
  cancelAppointment: async (id: string) => {
    const response = await cancelAppointment(id);
    return response.data;
  },
  createAppointment: async (data: Appointment) => {
    const response = await createAppointment(data);
    return response.data;
  },
};
